import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Icon, IconButton } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import ArtApi from "../api/ArtApi";

interface IAddCommentProps {
    eventId: string,
    addNoteToTable: Function
}

export const AddCommentDialog = (props: IAddCommentProps) => {
    const [error, setError] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [comment, setComment] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);


    const handleClose = () => {
        if (isSuccess) {
            let savedComment = comment;
            setComment("");
            props.addNoteToTable({ comment: savedComment, timestamp: new Date() });
        }
        setOpen(false);
        setError(null);
        setIsSuccess(false);
        setIsLoading(false);
        setSnackbarOpen(false);
    };

    const handleAddComment = () => {
        if (isSuccess) {
            handleClose();
        } else {
            setIsLoading(true);
            ArtApi.addComment(props.eventId, comment)
                .then(result => {
                    setIsLoading(false);
                    setIsSuccess(result.result);
                    if (result.error) {
                        setSnackbarOpen(true);
                        setError(result.error)
                    }
                }).catch(error => {
                    setIsLoading(false);
                    setSnackbarOpen(true);
                    setError(error.message);
                })
        }
    };

    return (
        <div>
            <Snackbar
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left"
                }}
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={() => setSnackbarOpen(false)}
            >
                <SnackbarContent
                    className="errorSnackbar"
                    message={
                        <span id="message-id" className="snackbarMessage">
                            <Icon className="snackbarIcon">error</Icon>
                            Error Occured: {error}
                        </span>
                    }
                    action={[
                        <IconButton
                            key="close"
                            aria-label="close"
                            color="inherit"
                            onClick={() => setSnackbarOpen(false)}
                        >
                            <Icon>close</Icon>
                        </IconButton>
                    ]}
                />
            </Snackbar>

            <IconButton style={{ float: "right" }} onClick={() => setOpen(true)}>
                <Icon>add_circle_icon</Icon>
            </IconButton>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Add Comment</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Add Comment to the Event
            </DialogContentText>
                    <TextField
                        id="comment"
                        label="Comment"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        margin="normal"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" variant="contained">
                        Cancel
            </Button>
                    <div className="buttonWrapper">
                        <Button
                            onClick={handleAddComment}
                            color="primary"
                            variant="contained"
                            disabled={isLoading}
                            className={isSuccess ? "buttonSuccess" : ""}
                        >
                            {isSuccess ? "Close" : "Add"}
                        </Button>
                        {isLoading && (
                            <CircularProgress size={24} className="buttonProgress" />
                        )}
                    </div>
                </DialogActions>
            </Dialog>
        </div>
    );
}
